var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"view"},[_c('Breadcrumb',{attrs:{"breadcrumb":_vm.breadcrumb}}),_c('h1',{staticClass:"view__title title--1"},[_vm._v(" you do not have permission for this section. contact your system administrator ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }